import React from 'react';

import BundleShowView from '@components/shared/bundles/BundleShowView';
import { useLoaderData } from 'react-router-dom';

const OperatorBundleShow: React.FC = () => {
  const bundle = useLoaderData() as React.ComponentProps<typeof BundleShowView>['bundle'];

  return (
    <BundleShowView
      bundle={bundle}
      role="operator"
    />
  );
};

export default OperatorBundleShow;
